import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";

export class FeedbackViewModel {
  public id: number;
  public hyp_cus_nr: number; // is it needs for ui? this is a liked location of user
  public message: string;
  public rating: number;
}

// Requests
export class FeedbackSyncModel extends SyncModel {
  public feedback: AddFeedbackModel[];
}

export class AddFeedbackModel {
  public message: string;
  public rating: number;
}

// Responses
export class FeedbackDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public app_version: string;
  // home location (or 0)
  public hyp_cus_nr: number;
  public message: string;
  // percent between 1 - 100 (or 0)
  public rating: number;
  public create_at_ymd: number;
  public create_at_hms: number;
  public get create_at(): Moment {
    return Utils.GetMomentFromInt(this.create_at_ymd, this.create_at_hms);
  }
}

export class FeedbackSyncDataModel extends SyncDataModel {
  public feedback: FeedbackDataModel[];
  public get models(): DataModel[] { return this.feedback; }
  public DeserializeType(): void {
    this._DeserializeType(FeedbackDataModel);
  }
}
